export const JOURNEY_CHANNELS = {
  facebook: { label: "META Paid", short: "META", color: "#60a5fa" },
  mobile: { label: "Mobile", short: "MOB", color: "#f472b6" },
  tiktok: { label: "TikTok", short: "TT", color: "#e879f9" },
  display: { label: "Social Mirror", short: "SM", color: "#22d3ee" },
  search: { label: "Google Search", short: "SRCH", color: "#fde047" },
  pmax: { label: "PMAX", short: "PMAX", color: "#fdba74" },
  ctv: { label: "CTV", short: "CTV", color: "#c4b5fd" },
  other: { label: "Other", short: "OTH", color: "#cbd5e1" },
};

export const channelMeta = (key) => JOURNEY_CHANNELS[key] || JOURNEY_CHANNELS.other;

export const groupByChannel = (items = []) => {
  const map = {};
  for (const it of items) {
    map[it.channel] = (map[it.channel] || 0) + 1;
  }
  return Object.entries(map).map(([channel, count]) => ({ channel, count }));
};

export const SPIKE_PCT = 20;
export const SPIKE_MIN_PRIOR = 100;
